<template>
    <div>
        <v-dialog
            persistent
            @click:outside="initCloseModal"
            v-model="showModal"
            max-width="1000px"
            class="settings-modal"
            eager
        >
            <v-card :loading="loading ? '#ff530d' : false">
                <!-- <v-card-title class="d-flex justify-space-between">
                    <span> Video Settings </span>

                    <v-btn @click="initCloseModal" small depressed fab>
                        <font-awesome-icon icon="fa-solid fa-x"></font-awesome-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider> -->
                <v-card-actions class="d-flex justify-end sticky-actions">
                    <v-btn @click="initCloseModal" depressed class="no-text-transform"> Close</v-btn>
                    <v-spacer></v-spacer>

                    <v-btn
                        v-if="tributeDefaultSettingsLink"
                        :disabled="disableUpdateBtn"
                        @click="openDefaultSettingsTab"
                        depressed
                        class="no-text-transform"
                    >
                        Default Settings</v-btn
                    >

                    <v-btn
                        :disabled="disableUpdateBtn"
                        :dark="!disableUpdateBtn"
                        @click="saveSettings"
                        :loading="loading"
                        depressed
                        class="no-text-transform"
                        color="#ff530d"
                    >
                        <font-awesome-icon icon="fa-solid fa-floppy-disk" class="mr-2" />
                        Save Settings</v-btn
                    >
                </v-card-actions>

                <v-card-text class="pt-4">
                    <TributeSettings
                        v-if="tributeVideo.id && token"
                        ref="settings"
                        mode="tribute"
                        :tributeVideoId="tributeVideo.id"
                        :funeralHomeId="tributeVideo.funeralHomeId"
                        :token="token"
                        @loading="val => (loading = val)"
                        @update-success="showModal = false"
                        @init-delete-ending-confirm="deleteEndingVideoConfirmModal = true"
                        @unsaved-changes="val => (unsavedChanges = val)"
                    />
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="closeWithoutSavingModal" max-width="400">
            <v-card>
                <v-card-title> Close without saving? </v-card-title>
                <v-card-text> Click confirm to close without saving changes. </v-card-text>

                <v-card-actions class="d-flex justify-end">
                    <v-btn class="no-text-transform" outlined @click="closeWithoutSavingModal = false" depressed
                        >Cancel</v-btn
                    >
                    <v-btn class="no-text-transform" @click="confirmCloseWithoutSaving" depressed color="error"
                        >Confirm</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import TributeSettings from '@/components/Tribute/TributeSettings.vue';

export default {
    data() {
        return {
            closeWithoutSavingModal: false,
            showModal: false,
            loading: false,
            confirmedClose: false,
            loading: false,
            token: null,
            unsavedChanges: false,
        };
    },
    inject: ['state'],
    components: { TributeSettings },
    computed: {
        disableUpdateBtn() {
            return this.loading;
        },

        tributeVideo() {
            return this.$store.state.tributeVideo;
        },
        tributeDefaultSettingsLink() {
            if (this.$auth.role.includes('SuperAdmin') && this.tributeVideo.funeralHomeId > 0) {
                return `${process.env.VUE_APP_BASE_URI}/homes/settings/${this.tributeVideo.funeralHomeId}?tab=tribute`;
            }

            if (this.$auth.role.includes('FuneralHome') || this.$auth.role.includes('Owner')) {
                const fhId = this.$auth?.user['https://memoryshare.com/funeral_home_id'];

                if (fhId > 0) {
                    return `${process.env.VUE_APP_BASE_URI}/settings?tab=tribute`;
                }
            }

            return null;
        },
    },
    watch: {
        showModal(newVal) {
            if (newVal) {
                this.getSettings();
            }
        },
    },
    methods: {
        openDefaultSettingsTab() {
            window.open(this.tributeDefaultSettingsLink, '_blank');
        },
        confirmCloseWithoutSaving() {
            this.closeWithoutSavingModal = false;
            this.showModal = false;
        },

        initCloseModal() {
            if (!this.unsavedChanges) {
                this.showModal = false;
            } else {
                this.closeWithoutSavingModal = true;
            }
        },
        async getSettings() {
            if (this.$refs.settings) {
                this.$refs.settings.getSettings();
            }
        },
        saveSettings() {
            if (this.$refs.settings) {
                this.$refs.settings.saveSettings();
            }
        },
        open() {
            this.showModal = true;
        },
        async setAuthToken() {
            if (this.state.token) {
                this.token = this.state.token;
            } else {
                const response = await this.$auth.getIdTokenClaims();
                this.token = response.__raw;
            }
        },
    },
    async mounted() {
        this.setAuthToken();
    },
};
</script>
<style lang="scss" scoped>
.sticky-actions {
    position: sticky;
    top: 0;
    background-color: white;
    border-bottom: 1px solid #eee;
    z-index: 2;
}
</style>
